import { render, staticRenderFns } from "./AvailabilityBlock.vue?vue&type=template&id=2a1f3e50&"
import script from "./AvailabilityBlock.vue?vue&type=script&lang=ts&"
export * from "./AvailabilityBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AvailabilityBlock.vue"
export default component.exports